const breadCrumb =
  "Lotação de Servidores - Manutenção de Informações do Servidor";

const routes = [
  {
    path: "/registrar-afastamento-do-servidor",
    name: "registrar-afastamento-do-servidor",
    meta: {
      allowedPermissions: ["afastamento_servidor_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/RegistrarAfastamentoDoServidor/RegistrarAfastamentoDoServidorHome.vue"
      ),
  },
  {
    path: "/registrar-afastamento-do-servidor/:lotacaoServidorId/listagem",
    name: "registrar-afastamento-do-servidor-listagem",
    meta: {
      allowedPermissions: ["afastamento_servidor_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/RegistrarAfastamentoDoServidor/RegistrarAfastamentoDoServidorListagem.vue"
      ),
  },
  {
    path: "/registrar-afastamento-do-servidor/:lotacaoServidorId/cadastro",
    name: "registrar-afastamento-do-servidor-cadastro",
    meta: {
      allowedPermissions: ["afastamento_servidor_insert"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/RegistrarAfastamentoDoServidor/RegistrarAfastamentoDoServidorCad.vue"
      ),
  },
  {
    path: "/registrar-afastamento-do-servidor/:lotacaoServidorId/visualizar/:afastamentoId",
    name: "registrar-afastamento-do-servidor-visualizar",
    meta: {
      allowedPermissions: ["afastamento_servidor_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/RegistrarAfastamentoDoServidor/RegistrarAfastamentoDoServidorVisualizar.vue"
      ),
  },
  {
    path: "/registrar-afastamento-do-servidor/:lotacaoServidorId/editar/:afastamentoId",
    name: "registrar-afastamento-do-servidor-editar",
    meta: {
      allowedPermissions: ["afastamento_servidor_atualizar"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/RegistrarAfastamentoDoServidor/RegistrarAfastamentoDoServidorEditar.vue"
      ),
  },
];

export default routes;
